export const getError = (error: any): string => {
  let errorMessage = "";
  if (error.response && error.response.data && error.response.data.message) {
    errorMessage = error.response.data.message;
  } else {
    errorMessage = "An error occurred while processing your request.";
  }
  return errorMessage;
};
